/**
 * Hero Section
 * Использует переиспользуемые компоненты
 */
import { Text, Button, Image, Container } from '../components';

const heightClasses = {
  small: 'min-h-[300px] md:min-h-[400px]',
  medium: 'min-h-[400px] md:min-h-[500px]',
  large: 'min-h-[500px] md:min-h-[600px]',
  fullscreen: 'min-h-screen',
};

const alignmentClasses = {
  left: 'text-left items-start',
  center: 'text-center items-center',
  right: 'text-right items-end',
};

const buttonsAlignmentClasses = {
  left: 'justify-start',
  center: 'justify-center',
  right: 'justify-end',
};

const contentAlignmentClasses = {
  left: '',
  center: 'mx-auto',
  right: 'ml-auto',
};

export default function HeroSection({ data, styles }) {
  const alignment = data?.alignment || 'left';
  const height = data?.height || 'large';
  const overlay = data?.backgroundOverlay ?? 0.5;
  const buttons = data?.buttons || [];

  return (
    <section
      className={`relative overflow-hidden ${heightClasses[height] || heightClasses.large}`}
      style={{
        backgroundColor: styles?.backgroundColor || '#1a1a1a',
        paddingTop: styles?.paddingTop || 0
      }}
    >
      {/* Background image */}
      {data?.backgroundImage && (
        <Image
          src={data.backgroundImage}
          alt={data?.title || ''}
          className="absolute inset-0 w-full h-full"
          fit="cover"
          loading="eager"
        />
      )}

      {/* Overlay */}
      <div
        className="absolute inset-0"
        style={{ backgroundColor: `rgba(0, 0, 0, ${overlay})` }}
      />

      {/* Content */}
      <div className={`relative h-full flex flex-col justify-center ${alignmentClasses[alignment] || alignmentClasses.left} px-4 py-12`}>
        <Container>
          <div className={`max-w-2xl ${contentAlignmentClasses[alignment] || ''}`}>
            {/* Заголовок - поддерживает как строку, так и объект с настройками */}
            <Text
              as="h1"
              data={typeof data?.title === 'object' ? data.title : { text: data?.title }}
              defaults={{ size: '4xl', weight: 'bold', color: 'white' }}
              className="mb-4 md:mb-6"
            />

            {/* Подзаголовок */}
            <Text
              as="p"
              data={typeof data?.subtitle === 'object' ? data.subtitle : { text: data?.subtitle }}
              defaults={{ size: 'xl', weight: 'normal', color: 'white-muted' }}
              className="mb-6 md:mb-8"
            />

            {buttons.length > 0 && (
              <div className={`flex flex-col sm:flex-row gap-3 md:gap-4 ${buttonsAlignmentClasses[alignment] || buttonsAlignmentClasses.left}`}>
                {buttons.map((button, index) => {
                  const textData = typeof button.text === 'object' ? button.text : { text: button.text || '' };
                  return (
                    <Button
                      key={button.id || index}
                      href={button.link || '#'}
                      variant={button.variant === 'primary' || !button.variant ? 'primary' : 'outline-white'}
                      size="lg"
                    >
                      <Text
                        as="span"
                        data={textData}
                        defaults={{ size: 'base', weight: 'medium', color: 'inherit' }}
                      />
                    </Button>
                  );
                })}
              </div>
            )}
          </div>
        </Container>
      </div>
    </section>
  );
}
